import { AchivementSales } from "./types"
import { ApprovalRequest, calcTotalUnitPrice } from "@/model/approvalRequest"

export const calcSalesSummary = ({
    reportedApprovalRequests
}: {
    reportedApprovalRequests: ApprovalRequest[]
}): AchivementSales => {
    let result = 0

    result += summarizeUnitPrice(reportedApprovalRequests)

    return result
}

export const summarizeUnitPrice = (
    reportedApprovalRequests: ApprovalRequest[]
): number => {
    return reportedApprovalRequests.reduce((acc, cur) => {
        return acc + (calcTotalUnitPrice(cur) ?? 0)
    }, 0)
}
